// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"918ced6d","50":"057be327","108":"f91d5c9f","129":"07375d4c","216":"8de30749","345":"41191498","362":"2789b491","381":"6d5a5a2c","592":"9cd45dc4","730":"4c0a1e70","789":"e71298c1","795":"7959fbb7","805":"2d7114ab","815":"789cd28e","869":"72df6d08","982":"d4b4ed38"}[chunkId] + ".chunk.js";
};